enum urlName {
  path = 'productos',
}

export default urlName;
